export default Object.freeze({
    IDLE: "idle",
    FIRST_SYNCHRONIZATION: "firstSynchronization",
    SYNCHRONIZATION: "synchronization",
});
